(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["againora-product-facts"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    const link = event.target.closest('[data-againora-open-details]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const details = document.getElementById(link.hash.slice(1));
    if (!details || details.tagName !== 'DETAILS') return;
    event.preventDefault();
    details.open = true;
    details.scrollIntoView({ block: 'start', behavior: 'auto' });
    details.querySelector('summary').focus({ preventScroll: true });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["againora-size-finder"] && !Shopify.designMode) return;
  try {
    class AgainoraFitFinder {
    constructor(root) {
      this.root=root;this.form=root.querySelector('form');this.category=root.querySelector('[data-fit-category]');this.sizes=root.querySelector('[data-fit-sizes]');this.status=root.querySelector('[role="status"]');this.submit=this.form.querySelector('[type="submit"]');this.options=[...root.querySelector('template').content.querySelectorAll('option')];this.generation=0;
      root.querySelector('[data-fit-controls]').hidden=false;root.querySelector('[data-fit-fallback]').hidden=true;
      root.querySelectorAll('[name="af-department"]').forEach(radio=>{radio.disabled=!this.options.some(o=>o.dataset.department===radio.value);radio.addEventListener('change',()=>this.department(radio.value));});
      this.category.addEventListener('change',()=>{this.sizes.replaceChildren();this.load();});
      this.sizes.addEventListener('change',()=>this.load());
      root.querySelector('[data-fit-reset]').addEventListener('click',()=>{this.sizes.querySelectorAll('select').forEach(s=>s.value='');this.load();});
      this.form.addEventListener('submit',event=>{event.preventDefault();if(!this.submit.disabled)location.assign(this.url().href);});
      const first=[...root.querySelectorAll('[name="af-department"]')].find(r=>!r.disabled);if(first){first.checked=true;this.department(first.value);}
    }
    department(value) {
      const previous=this.category.selectedOptions[0]?.dataset.handle.replace(/^(mens|womens)-/,'');
      this.category.replaceChildren(...this.options.filter(o=>o.dataset.department===value).map(o=>o.cloneNode(true)));
      const match=[...this.category.options].find(o=>o.dataset.handle===value+'-'+previous);
      if(match)this.category.value=match.value;
      this.sizes.replaceChildren();this.load();
    }
    url() {
      const url=new URL(this.category.value,location.origin);url.searchParams.set('filter.v.availability','1');
      const tags=[];
      for(const select of this.sizes.querySelectorAll('select'))if(select.value){
        const tag=select.selectedOptions[0]?.dataset.collectionTag;
        if(tag)tags.push(tag);
        else url.searchParams.set(select.name,select.value);
      }
      if(tags.length)url.pathname=url.pathname.replace(/\/$/,'')+'/'+tags.join('+');
      return url;
    }
    async load(reconciled=false) {
      const generation=++this.generation;this.abort?.abort();this.abort=new AbortController();
      this.submit.disabled=true;this.status.textContent=this.root.dataset.loading;this.form.setAttribute('aria-busy','true');
      this.form.action=this.category.value;this.root.querySelector('[data-fit-browse]').href=this.category.value;
      const selected=new Map([...this.sizes.querySelectorAll('select')].map(s=>[s.name,s.value]));const focused=document.activeElement?.name;
      const url=this.url();url.searchParams.set('section_id','againora-size-options');
      try {
        const response=await fetch(url,{credentials:'same-origin',signal:this.abort.signal,cache:'no-store'});if(!response.ok)throw Error('Unavailable');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');const payload=doc.querySelector('[data-size-payload]');if(!payload)throw Error('Missing sizes');if(generation!==this.generation)return;
        const labels=[...payload.querySelectorAll('.af-field')];
        const rank={XXS:0,'2XS':0,XS:1,S:2,M:3,L:4,XL:5,XXL:6,'2XL':6,'3XL':7,'4XL':8,'5XL':9,'6XL':10};
        for(const label of labels){const s=label.querySelector('select');const options=[...s.options].slice(1);const seen=new Set();const jeans=s.name.endsWith('waist_size')||s.name.endsWith('inside_leg');const choices=options.filter(o=>{if(jeans&&!/^\d+(?:[.,]\d+)?\s*(?:in(?:ch(?:es)?)?|"|″)?$/i.test(o.value.replace(/^Filter (?:waist|length):\s*/i,'').trim()))return false;const key=o.value.trim().toUpperCase();if(seen.has(key)||['DEFAULT TITLE','UNKNOWN','N/A','NOT SPECIFIED'].includes(key))return false;seen.add(key);return true;}).sort((a,b)=>{const x=a.textContent.trim().toUpperCase(),y=b.textContent.trim().toUpperCase();return x in rank&&y in rank?rank[x]-rank[y]||x.localeCompare(y):x.localeCompare(y,undefined,{numeric:true,sensitivity:'base'});});const value=s.value;s.replaceChildren(s.options[0],...choices);s.value=choices.some(o=>o.value===value)?value:'';}
        labels.sort((a,b)=>a.querySelector('select').name.endsWith('waist_size')?-1:b.querySelector('select').name.endsWith('waist_size')?1:0);
        this.sizes.replaceChildren(...labels.map(label=>document.importNode(label,true)));
        const changed=[...selected].some(([name,value])=>value&&[...this.sizes.querySelectorAll('select')].find(s=>s.name===name)?.value!==value);
        if(changed&&!reconciled){this.load(true);return;}
        const count=Number(payload.dataset.count);this.submit.textContent=payload.dataset.resultLabel;this.submit.disabled=!Number.isFinite(count)||count===0;
        this.status.textContent=count===0?this.root.dataset.empty:'';
        if(!labels.length&&count>0)this.status.textContent=this.root.dataset.error;
        this.form.removeAttribute('aria-busy');
        if(focused&&this.root.contains(document.activeElement)||document.activeElement===document.body){const target=[...this.sizes.querySelectorAll('select')].find(s=>s.name===focused);target?.focus({preventScroll:true});}
      } catch(error) {
        if(error.name==='AbortError'||generation!==this.generation)return;
        this.status.textContent=this.root.dataset.error;this.form.removeAttribute('aria-busy');
      }
    }
  }
  function initAgainoraFit(scope){scope.querySelectorAll('[data-fit-finder]:not([data-initialized])').forEach(root=>{root.dataset.initialized='true';new AgainoraFitFinder(root);});}
  initAgainoraFit(document);document.addEventListener('shopify:section:load',event=>initAgainoraFit(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["editorial-localization"] && !Shopify.designMode) return;
  try {
    (() => {
    const panel = document.getElementById('AgainoraPreferencesPanel');
    const form = document.getElementById('AgainoraLocalization');
    if (!panel || !form || form.dataset.preferencesReady) return;
    form.dataset.preferencesReady = 'true';
    const country = form.querySelector('[name="country_code"]');
    const currency = form.querySelector('[data-preferences-currency]');
    const triggers = Array.from(document.querySelectorAll('.againora-market-trigger'));
    const refreshCurrency = () => { currency.textContent = country.selectedOptions[0]?.dataset.currency || currency.textContent; };
    const placePanel = trigger => {
      if (!trigger) return;
      const rect = trigger.getBoundingClientRect();
      panel.style.setProperty('--againora-market-top', Math.max(12, Math.min(rect.bottom + 8, innerHeight - 410)) + 'px');
      panel.style.setProperty('--againora-market-right', Math.max(16, innerWidth - rect.right) + 'px');
    };
    triggers.forEach(trigger => trigger.addEventListener('click', () => placePanel(trigger)));
    panel.addEventListener('toggle', event => {
      const open = event.newState === 'open';
      triggers.forEach(trigger => trigger.setAttribute('aria-expanded', String(open)));
      if (!open) { form.reset(); refreshCurrency(); }
    });
    country.addEventListener('change', refreshCurrency);
    form.addEventListener('submit', () => {
      let input = form.querySelector('[name="return_to"]');
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'return_to'; form.append(input); }
      input.value = location.pathname + location.search + location.hash;
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
